import { render, staticRenderFns } from "./ElemTable.vue?vue&type=template&id=b3958f1e&scoped=true&"
import script from "./ElemTable.vue?vue&type=script&lang=js&"
export * from "./ElemTable.vue?vue&type=script&lang=js&"
import style0 from "./ElemTable.vue?vue&type=style&index=0&id=b3958f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3958f1e",
  null
  
)

export default component.exports